// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__y_3Tw","content":"styles_content__3nbeZ","selectAll":"styles_selectAll__EuoNL"};